import {
  Component,
  Input,
  Host,
  OnInit,
  AfterViewInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { CheckboxGroupComponent } from '../checkbox-group/checkbox-group.component';

@Component({
  selector: 'checkbox-elem',
  template: `
    <input
      type="checkbox"
      class="btn-check"
      id="btn-check-outlined-{{ context }}-{{ value }}"
      [checked]="isCheckedVal"
    />
    <label
      class="btn btn-outline-primary btn-check-styling btn-check-{{ context }}"
      for="btn-check-outlined-{{ context }}-{{ value }}"
      (click)="toggleCheck()"
      >{{ label }}</label
    >
  `,
  styles: [
    `
      .btn-check-styling {
        font-size: 14px;
        margin: 0px 3px 5px 0px;
        color: #131313;
        border: 1px solid #d1d5db;
      }
      .btn-check:checked + .btn-check-type {
        color: white !important;
        background-color: $brand01dark;
      }
      .btn-check:checked + .btn-check-piece {
        color: white !important;
        background-color: $brand01dark;
      }

      .btn-check:checked + .btn-check-room {
        color: white !important;
        background-color: $brand01dark;
      }

      .btn-check:checked + .btn-check-security {
        color: white !important;
        background-color: $brand01dark;
      }
      .btn-check:checked + .btn-check-comodity {
        color: white !important;
        background-color: $brand01dark;
      }
    `,
  ],
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Input() value: any;
  @Input() label: any;
  @Input() context: any;
  @Input() element: any;
  @Input() reinitilize: any;

  isCheckedVal = false;

  constructor(@Host() private checkboxGroup: CheckboxGroupComponent) {}
  ngOnInit(): void {
    if (this.checkboxGroup.defaultElements?.indexOf(this.value) > -1) {
      this.checkboxGroup.addWithoutEvent(this.value);
      this.isChecked();
    }
  }

  ngOnChanges(changements: SimpleChanges) {
    this.isChecked();
    if (changements.reinitilize) {
      if (
        !changements.reinitilize.previousValue &&
        changements.reinitilize.currentValue
      ) {
        this.uncheck();
      }
    }
  }

  toggleCheck() {
    this.checkboxGroup.addOrRemove(this.value);
    this.isChecked();
  }
  uncheck() {
    this.checkboxGroup.removeWithoutEvent(this.value);
    this.isChecked();
  }

  isChecked() {
    let this_ = this;
    setTimeout(function () {
      this_.isCheckedVal = this_.checkboxGroup.contains(this_.value);
    }, 100);
  }
}
